document.addEventListener('DOMContentLoaded', function() {
    // Seleciona os elementos
    const links = document.querySelectorAll('.links a');
    const produtos = document.querySelectorAll('.lista-produtos .col-lg-4');
    const conteudoExclusivo = document.querySelector('.conteudo-exclusivo');

    // Função para filtrar produtos
    function filtrarProdutos(tipo) {
        produtos.forEach(produto => {
            const produtoTipo = produto.getAttribute('data-type');
            
            if (tipo === 'todos' || produtoTipo === tipo) {
                produto.classList.remove('hidden');
            } else {
                produto.classList.add('hidden');
            }
        });
    }

    // Função para mostrar/ocultar conteúdo exclusivo
    function toggleConteudoExclusivo(mostrar) {
        if (mostrar) {
            conteudoExclusivo?.classList.remove('hidden');
        } else {
            conteudoExclusivo?.classList.add('hidden');
        }
    }

    // Função principal para mudar o filtro
    function aplicarFiltro(tipo, mostrarExclusivo) {
        filtrarProdutos(tipo);
        toggleConteudoExclusivo(mostrarExclusivo);
    }

    // Adiciona evento de clique em cada link
    links.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove active de todos e adiciona no clicado
            links.forEach(l => l.classList.remove('active'));
            this.classList.add('active');
            
            const type = this.getAttribute('type');
            
            if (type === 'exclusive') {
                aplicarFiltro('exclusivo', true);
            } 
            else if (type === 'traditional') {
                aplicarFiltro('tradicional', false);
            }
        });
    });

    // 🎯 INICIALIZAÇÃO: Define o estado padrão ao carregar a página
    function inicializar() {
        // Define "Produtos Tradicionais" como ativo
        links.forEach(l => {
            if (l.getAttribute('type') === 'traditional' && l.classList.contains('active')) {
                // Aplica o filtro tradicional e esconde a seção exclusiva
                aplicarFiltro('tradicional', false);
            } else {
                aplicarFiltro('exclusivo', true);
            }
        });
    
    }

    // Executa a inicialização
    inicializar();

    // Card "Processo de Desenvolvimento": não é um produto, apenas leva até a seção
    const linkProcesso = document.querySelector('.js-scroll-processo');

    if (linkProcesso && conteudoExclusivo) {
        linkProcesso.addEventListener('click', function(e) {
            e.preventDefault();

            const header = document.querySelector('header');
            const offset = header ? header.offsetHeight + 24 : 24;
            const topo = conteudoExclusivo.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({ top: topo, behavior: 'smooth' });

            // Destaca a seção por um instante para o usuário identificar o destino
            conteudoExclusivo.classList.add('destaque');
            setTimeout(() => conteudoExclusivo.classList.remove('destaque'), 1600);
        });
    }
});